import React, { Fragment, useRef, useState } from "react"
import { Box, IconButton, Typography, useTheme } from "@mui/material"
import UploadIcon from "assets/icons/UploadIcon.svg"
import TransparentImageIcon from "assets/icons/UploadIconBlue.svg"
import RedCloseIcon from "assets/icons/RedCloseIcon.svg"
import GreenCheckIcon from "assets/icons/GreenCheckIcon.svg"
import AppButton from "components/StyledComponents/AppButton"
import styles from "./DragAndDrop.module.scss"
import { CropFreeOutlined } from "@mui/icons-material"

function CommonDragAndDrop({
  type,
  setAllFilesSelected,
  onChange,
  setDisable,
  accept,
  preview,
  selectedFile,
  setSelectedFile
}) {
  const inputFile = useRef(null)
  const [fileError, setFileError] = useState("")
  const theme = useTheme()
  const onBrowseClick = () => {
    inputFile.current.click()
  }

  const saveFiles = (files) => {
    const file = files[0]
    setSelectedFile(file)
    onChange(file)
    setAllFilesSelected((prev) => (type === "CSV" ? { ...prev, csvUploaded: true } : prev))
    setDisable(true)
  }

  const isFileAccepted = (file) => {
    if (!accept) {
      return true
    }
    const extension = file.name.split(".").pop().toLowerCase()
    const acceptedTypes = accept.split(",").map((type) => type.trim().replace(".", ""))
    return acceptedTypes.includes(extension)
  }

  const onFilesSelected = (e) => {
    const { files } = e.target
    if (files && files.length) {
      const file = files[0]
      if (!isFileAccepted(file)) {
        setFileError(`Please upload a ${accept} file`)
        setDisable(false)
        return
      }

      saveFiles(files)
      setFileError("")
    }
  }

  const handleDelete = () => {
    setSelectedFile(null)
    setAllFilesSelected({})
    setDisable(false)
  }

  const handleDragOver = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const { files } = e.dataTransfer

    if (files && files.length) {
      const file = files[0]
      if (!isFileAccepted(file)) {
        setFileError(`Please upload a ${accept} file`)
        setDisable(false)
        return
      }
      saveFiles(files)
      setFileError("")
    }
  }

  return (
    <Fragment>
      {selectedFile ? (
        <Box>
          {preview && selectedFile?.type === "application/pdf" ? (
            <Box mt={2} position="relative">
              <IconButton
                className={styles.expandButton}
                onClick={() => window.open(URL.createObjectURL(selectedFile), "_blank")}>
                <CropFreeOutlined className={styles.expandIcon} />
              </IconButton>
              <iframe
                src={`${URL.createObjectURL(selectedFile)}#toolbar=0&navpanes=0&scrollbar=0`}
                width="100%"
                height="500px"
                title="PDF Preview"
              />
            </Box>
          ) : preview && selectedFile?.type?.startsWith("image/") ? (
            <Box mt={2} position="relative">
              <IconButton
                className={styles.expandButton}
                onClick={() => window.open(URL.createObjectURL(selectedFile), "_blank")}>
                <CropFreeOutlined className={styles.expandIcon} />
              </IconButton>
              <img
                src={URL.createObjectURL(selectedFile)}
                alt="Preview"
                style={{
                  width: "100%",
                  maxHeight: "500px",
                  objectFit: "contain",
                  display: "block"
                }}
              />
            </Box>
          ) : (
            <Box className={styles.uploadCtr} style={{ height: "auto", marginBottom: 30 }}>
              <Typography variant="body1Regular">{type === "Video" ? "Video" : ""}</Typography>
              <Box className={styles.imageListItem}>
                <Box className={styles.imageItemInnerCtr}>
                  <img src={TransparentImageIcon} alt="" className="me-4" />
                  <Typography className="ms-1 me-3" variant="body1Regular">
                    {selectedFile?.name?.length > 30
                      ? `${selectedFile?.name?.slice(0, 30)}...`
                      : selectedFile?.name}
                  </Typography>
                  <img src={GreenCheckIcon} alt="" />
                </Box>
                <img
                  className={styles.deleteBtn}
                  src={RedCloseIcon}
                  onClick={handleDelete}
                  alt="delete"
                />
              </Box>
            </Box>
          )}
          <Typography variant="body1Regular" sx={{ color: theme.palette.error.main }}>
            {`${fileError}`}
          </Typography>
        </Box>
      ) : (
        <Box>
          <div className={styles.uploadCtr} onDragOver={handleDragOver} onDrop={handleDrop}>
            <Box className={styles.innerUploadCtr}>
              <img src={UploadIcon} alt="" />
              <Typography variant="h3Italic">Drag And Drop {type}</Typography>
              <Typography className={styles.imgUploadHelperText} variant="body1Regular">
                or select files from device
              </Typography>
              <AppButton className={styles.browseBtn} onClick={onBrowseClick}>
                Browse
              </AppButton>
              <input
                type="file"
                id="file"
                ref={inputFile}
                style={{ display: "none" }}
                onChange={onFilesSelected}
                {...(accept ? { accept } : {})}
              />
            </Box>
          </div>
        </Box>
      )}
    </Fragment>
  )
}

export default CommonDragAndDrop
